import { ReactNode, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { DNDSortableListItem } from './DNDSortableListItem';
import { DNDPreview } from './DNDPreview';

export function DNDSortableList<T>({items, itemElementTag, renderItemContents, moveItem}: Props<T>) 
{
    const [itemTypeId,] = useState(Math.random() + '');
    const isTouch = 'ontouchstart' in window

    return (
        <DndProvider backend={isTouch ? TouchBackend : HTML5Backend}>
            {items.map(function(item, index)
            {
                return <DNDSortableListItem
                    key={index}
                    index={index}
                    itemTypeId={itemTypeId}
                    isTouch={isTouch}
                    elementTag={itemElementTag}
                    moveItem={moveItem}
                    children={renderItemContents(item, index)}
                    preview={renderItemContents(item, index)}/>;
            })}
            {isTouch ? <DNDPreview elementTag={itemElementTag}/> : <></>}
        </DndProvider>
    );
}

interface Props<T>
{
    items: T[];
    itemElementTag: string;
    renderItemContents: (item: T, index: number) => ReactNode;
    moveItem: (oldIndex: number, newIndex: number) => void;
};